import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ServerResponse } from '../../models/serverResponse';
import { TranslateService } from '@ngx-translate/core';
import { FileService } from '@services/file.service';

@Component({
	selector: 'app-send',
	templateUrl: './send.component.html',
	styleUrls: ['./send.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Send Component.
 */
export class SendComponent implements OnInit
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Subscription for http request.
	 */
	private httpSubscription: Subscription;

	/**
	 * State.
	 */
	public state = 'transfer';

	/**
	 * Language.
	 */
	private language: string;

	/**
	 * Constructor.
	 */
	public constructor(
		private http: HttpClient,
		private location: Location,
		private router: Router,
		private translateService: TranslateService,
		private fileService: FileService
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		// Language.
		this.language = this.translateService.currentLang;

		this.sendData();
	}

	/**
	 * Send data to server.
	 */
	private sendData()
	{
		const user = this.retrieveStorage('user');

		if (user && !this.httpSubscription)
		{
			const api = environment.apiUrl + '/common/ajax.php?bereich=portal&modul_id=101&klasse=city_app_ajax&com=InsertForm';
			const uploadURL = environment.apiUrl + '/common/ajax.php?bereich=portal&modul_id=101&klasse=city_app_ajax&com=UploadFile';

			const formData = new FormData();

			// Files.
			const filenames = this.fileService.getFilenames();

			// User.
			formData.append('text', user['text']);
			formData.append('email', user['email']);
			formData.append('salutation', user['salutation']);
			formData.append('title', user['title']);
			formData.append('name', user['name']);
			formData.append('surname', user['surname']);
			formData.append('company', user['company']);
			formData.append('position', user['position']);
			formData.append('area', user['area']);
			formData.append('language', this.language);
			formData.append('files', JSON.stringify(filenames));
			formData.append('contact', user['contact']);
			formData.append('postal', user['postal']);
			formData.append('electronic', user['electronic']);

			this.httpSubscription = this.http.post(api, formData, {withCredentials: true}).subscribe((serverResponse: ServerResponse) => {
					if (serverResponse.success === true)
					{
						localStorage.setItem('user', null);

						// file upload.
						const files = this.fileService.getStore();
						const id = serverResponse.data['system_id'];

						if (files.length > 0)
						{
							let uploaded = 0;

							for (let file of files)
							{
								const uploadData = new FormData();

								uploadData.append('uploadFile', file);
								uploadData.append('formId', id);

								this.http.post(uploadURL, uploadData, {withCredentials: true}).subscribe((uploadResponse: ServerResponse) => {
									if (uploadResponse.success === true)
									{
										uploaded++;

										if (uploaded == files.length)
										{
											this.fileService.clearFiles();
											this.state = 'success';
										}
									}
								});
							}
						}
						else
						{
							this.state = 'success';
						}
					}
					else
					{
						this.state = 'error';
					}
				},
				() => {
					this.state = 'error';
			});
		}
	}

	/**
	 * Receive data from the local storage.
	 */
	private retrieveStorage(item: string)
	{
		return JSON.parse(localStorage.getItem(item));
	}

	/**
	 * Eventhandler: Back to stage (Success).
	 */
	public onBackToStage()
	{
		this.httpSubscription.unsubscribe();
		this.router.navigateByUrl('/portal/stage');
	}

	/**
	 * Eventhandler: Back to form (Error).
	 */
	public onBackToForm()
	{
		this.httpSubscription.unsubscribe();
		this.location.back();
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/send/send.component.ts